import React from 'react';

export interface ButtonWidgetConfig {
  displayName: string;
  className: string;
  functionName: string;
}

interface ButtonWidgetProps {
  id?: string;
  config?: ButtonWidgetConfig;
  widgetId?: string;
  isSelected?: boolean;
}

const defaultConfig: ButtonWidgetConfig = {
  displayName: 'Button',
  className: '',
  functionName: ''
};

export const ButtonWidget: React.FC<ButtonWidgetProps> = ({
  id,
  config = defaultConfig,
  isSelected = false
}) => {
  const baseId = id || 'button-widget';
  const mergedConfig = { ...defaultConfig, ...config };

  const backgroundClass = isSelected ? 'tw-bg-transparent' : 'tw-bg-transparent';

  return (
    <div id={baseId} className={`tw-w-full tw-p-4 ${backgroundClass}`}>
      <button
        id={`${baseId}-btn`}
        data-testid={`${baseId}-btn`}
        className={`tw-px-4 tw-py-2 tw-border tw-border-[#6D788C] tw-bg-[#DADBDD] tw-text-[#172B4D] tw-text-xs tw-font-medium  ${mergedConfig.className}`}
        disabled={true}
      >
        {mergedConfig.displayName}
      </button>
    </div>
  );
};

export default ButtonWidget;
